import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import { showModal } from '../../features/modal/modalSlice'
import { useEffect, useState } from 'react'
import InputNumberNew from '../../components/shared/input/new/InputNumberNew'
import Btn from '../../components/shared/button/Btn'
import ProfilimKullanicilarContainer from '../../components/profilimContainer/ProfilKullanicilar'
import { getSubUsers } from '../../features/companyProfile/companyAuthorizationSlice'

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;
        gap: 20px;
        
        p{
          font-size: var(--font-size-lg);
          font-weight: var(--font-weight-lg);
          text-align: center;
        }

        .btn-group{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 20px;
        }

        .filter-container{
          width: 100%;
          height: auto;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 20px 0;

          .filter-input-grp{
            margin: 0 2px;
            display: flex;
            gap: 20px;
          }

        }
        .titles{
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
          text-align: center;
          gap: 15px;
          padding: 15px 10px;
          p{
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-md);
          }
        }
    }
}
`

const Kullanicilar = () => {

    const dispatch = useDispatch()
    
    const {subUserList} = useSelector((state) => state.companyAuthorization)

    const [phoneNumber, setPhoneNumber] = useState("")

    useEffect(() => {
      dispatch(getSubUsers())
    },[])

    const titles = ["Adı Soyadı", "Mail Adresi", "Telefonu", "Kullanıcı Türü", "Aktif/Pasif"]

    return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kullanıcılar"} position='sticky'/>
      <div className="content"> 
   
        <div className="filter-container">
          <div className="filter-input-grp">
            <InputNumberNew data={phoneNumber} setData={(e) => setPhoneNumber(e.target.value)} inputWidth={"220px"} labelText={"Telefon Numarası"}/>
            <Btn bgColor={"transparent"} color={"#E85446"} padding='0 10px' width='160px' >Temizle</Btn>
          </div>
          <Btn bgColor={"transparent"} color={"#E85446"} handleClick={()=> dispatch(showModal("addProfilimKullanici"))} padding='0 10px' width='160px' >Kullanıcı Ekle</Btn>
        
        </div>

        <div className="titles">
          {titles.map((item) => {
            return(
              <p>{item}</p>
            )
          })}
        </div>

        {subUserList?.map((item) => (
          <ProfilimKullanicilarContainer data={item} />
        ))}
    
      </div>
    </div>
  </Container>
  )
}

export default Kullanicilar